import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";
import { PublicInterceptor } from "../../../Base/interceptors/PublicInterceptor";
// OBTIENER LISTADO DE BANCOS
export const getListaCorreo = async() => {
    const result = await PrivateInterceptor(`IT/ListaCorreo`, 'GET')
    return result;
}
export const changeListaCorreo = async(ListaCorreo) => {
    const result = await PrivateInterceptor(`IT/ListaCorreo`, 'POST', ListaCorreo)
    return result;
}

export const getCorreos = async (IdListaCorreo) => {
   const result = await PrivateInterceptor(`IT/ListaCorreo/${IdListaCorreo}`)
   return result
}

export const getListaCorreoToken = async(Token) => {
    const result = await PublicInterceptor(`IT/ListaCorreo`, 'GET', {}, Token)
    return result;
}
